var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssignedOffice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.86634 9.49997L5.66634 8.69997C4.99967 8.0333 4.66634 7.16663 4.66634 6.36663C4.66634 5.49997 4.99967 4.6333 5.66634 4.0333L4.86634 3.2333C3.99967 4.09997 3.53301 5.2333 3.53301 6.36663C3.53301 7.49997 3.99967 8.6333 4.86634 9.49997Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.733 1.6333L11.933 2.4333C12.9997 3.49997 13.533 4.96663 13.533 6.36663C13.533 7.76663 12.9997 9.2333 11.933 10.3L12.733 11.1C14.0663 9.76663 14.6663 8.09997 14.6663 6.36663C14.6663 4.6333 13.9997 2.96663 12.733 1.6333Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.06634 2.4333L3.26634 1.6333C1.99967 2.96663 1.33301 4.6333 1.33301 6.36663C1.33301 8.09997 1.99967 9.76663 3.26634 11.1L4.06634 10.3C2.99967 9.2333 2.46634 7.76663 2.46634 6.36663C2.46634 4.96663 2.99967 3.49997 4.06634 2.4333Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.133 9.49997C11.9997 8.6333 12.4663 7.49997 12.4663 6.36663C12.3997 5.2333 11.9997 4.09997 11.133 3.2333L10.333 4.0333C10.9997 4.69997 11.333 5.56663 11.333 6.36663C11.333 7.2333 10.9997 8.09997 10.333 8.69997L11.133 9.49997Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66634 6.36663C9.66634 5.44663 8.91967 4.69997 7.99967 4.69997C7.07967 4.69997 6.33301 5.44663 6.33301 6.36663C6.33301 6.8733 6.55967 7.3133 6.91301 7.61997L4.66634 14.3666H5.99967L6.44634 13.0333H9.55967L9.99967 14.3666H11.333L9.08634 7.61997C9.43967 7.3133 9.66634 6.8733 9.66634 6.36663ZM6.88634 11.7L7.99967 8.36663L9.11301 11.7H6.88634Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignedOffice);
export default __webpack_public_path__ + "static/media/assigned_office.1a9f95e3579c06041789825e03472ac6.svg";
export { ForwardRef as ReactComponent };